import React, {FC, useRef, useEffect} from 'react'

import Form from '@/components/Form'
import { Button } from '@/components/UiElements'

import hatchPatternFormItems from '@/components/HatchProfile/forms/hatchPatternFormItems'

interface HatchPatternFormProps {
	pattern: any | null
	onUpdateSuccess: (pattern: any) => void
}


const HatchPatternForm: FC<HatchPatternFormProps> = ({ pattern, onUpdateSuccess }) => {

	const formRef = useRef<any>(null)

	const handleSavePattern = ()=> {
		const data = formRef.current?.getData()
		console.log(data)
		onUpdateSuccess(data)
	}

	useEffect(() => {
		formRef?.current?.setData(pattern || {})
		console.log(pattern, "profile in form")
	}, [pattern])

	return (
		<div className={'flex flex-col gap-xxxl'}>
			<div className={'w-[700px] grid grid-cols-12 gap-md'}>
				<Form
					ref={formRef}
					items={hatchPatternFormItems}
					defaultValues={pattern || {}}

				/>
			</div>
			<Button
				size="lg"
				onClick={handleSavePattern}
			>
				{pattern ? 'Update Hatch Pattern' : 'Add Hatch Patteern'}
			</Button>
		</div>
	)
}


export default HatchPatternForm

